import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getExpressParams, putExpress } from '../../../service/api';
import UserEditMain from '../../presentation/section/user-edit/UserEditMain';
import md5 from 'md5';

const UserEdit = (props) => {
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfimPassword] = useState('');
  const [username, setUsername] = useState('');
  const [role, setRole] = useState('');
  const [saveTooltip, setSaveTooltip] = useState('test')

  useEffect(() => {
    getExpressParams('/account/info/email', {
      email: props.currentUser
    }, (response) => {
      setUsername(response.data.name);
      setRole(response.data.role);
    })
  }, [])


  const handleSave = () => {
    const hashedPassword = md5(password+"{"+props.currentUser+"}");
    const hashedNewPassword = md5(newPassword+"{"+props.currentUser+"}");
    if(newPassword==confirmPassword && newPassword.length >= 8){
      putExpress('/account/info', {
        email: props.currentUser,
        password: hashedPassword,
        newPassword: hashedNewPassword,
        fullname: username
      }, (response) => {
        if (response.data.code == 0){
          setPassword('')
          setNewPassword('')
          setConfimPassword('')
          setSaveTooltip('저장되었습니다.')
        }
        else if ( response.data.code == 3) {
          setSaveTooltip('현재 패스워드와 일치하지 않습니다.')
        }
      })
    }
    else {
      setSaveTooltip('새 패스워드 확인을 다시 해주세요.')
    }
  }

  const handleConfirmPassword = (event) => {
    setConfimPassword(event.target.value)
  }

  const handlePassword = (event) => {
    setPassword(event.target.value);
  }

  const handleNewPassword = (event) => {
    setNewPassword(event.target.value);
  }

  const handleUsername = (event) => {
    setUsername(event.target.value)
  }

  return(
    <UserEditMain email={props.currentUser} role={role} username={username} password={password} newPassword={newPassword} confirmPassword={confirmPassword}
      handlePassword={handlePassword} handleNewPassword={handleNewPassword} handleUsername={handleUsername} handleConfirmPassword={handleConfirmPassword}
      handleSave={handleSave} saveTooltip={saveTooltip}
    />
  )
}

const mapStateToProps = (state) => ({
    currentUser: state.AuthManager.status.currentUser
})

export default connect(mapStateToProps) (UserEdit);